module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/gEQvYcyUPmk0sAeAaSauK-12296e2974c2e91c7cdf9f1398f08fe1.jpg";